import React from 'react'

const WhyCritical = () => {
  return (
    <>
     <div id="cyber-security" className="container py-5 mt-5">
      <h2 className="text-center mb-4 mt-5">Why Cyber Security is Critical?</h2>
      <p className="text-justify">
        In today's digital age, cyber security is essential to protect sensitive 
        information, secure business operations, and ensure data privacy. With the 
        increasing number of cyber threats, a robust cyber security framework helps 
        prevent financial losses, safeguard reputation, and maintain trust in technology.
      </p>
    </div>
    </>
  )
}

export default WhyCritical